module.exports = __webpack_public_path__ + "img/left.5f2aa67f.png";